import { getState, signalStore, withMethods, withState } from '@ngrx/signals';
import { User, UserRole } from '@clientwire/api';
import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';

export type UserState = Omit<User, 'role'> & {
  role: UserRole | null;
};

const initialState: UserState = {
  id: '',
  email: '',
  role: null,
  firstname: '',
  lastname: '',
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withDevtools('user-store'),
  withState(initialState),
  withMethods((store) => {
    return {
      setUser(user: User) {
        updateState(store, 'Set user', user);
      },

      clearUser() {
        updateState(store, 'Clear user', initialState);
        updateState(store, 'Clear entities');
      },

      getUser() {
        return getState(store);
      },
    };
  })
);
